import { useEffect, useMemo, useState } from "react";

function parseEndTimeMs(value) {
  if (value == null || value === "") return null;

  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : null;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    return value > 1e12 ? Math.floor(value) : Math.floor(value * 1000);
  }

  const text = String(value).trim();
  if (!text) return null;

  if (/^\d+$/.test(text)) {
    const num = Number(text);
    if (!Number.isFinite(num)) return null;
    return num > 1e12 ? Math.floor(num) : Math.floor(num * 1000);
  }

  // MySQL datetime fallback from legacy responses, assume UTC.
  const mysqlLike = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
  const normalized = mysqlLike.test(text) ? `${text.replace(" ", "T")}Z` : text;
  const asMs = Date.parse(normalized);
  return Number.isFinite(asMs) ? asMs : null;
}

function pad2(value) {
  return String(value).padStart(2, "0");
}

function formatRemainHms(totalSec) {
  const hours = Math.floor(totalSec / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  return `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}`;
}

export default function AuctionCountdown({
  endTime,
  nowMs,
  showLabel = false,
  className = "",
}) {
  const endMs = useMemo(() => parseEndTimeMs(endTime), [endTime]);
  const hasExternalNow = typeof nowMs === "number" && Number.isFinite(nowMs);
  const [innerNowMs, setInnerNowMs] = useState(() => Date.now());
  const currentNowMs = hasExternalNow ? nowMs : innerNowMs;

  useEffect(() => {
    if (hasExternalNow) return undefined;
    const timer = window.setInterval(() => {
      setInnerNowMs(Date.now());
    }, 1000);
    return () => window.clearInterval(timer);
  }, [hasExternalNow]);

  const remainSec = useMemo(() => {
    if (endMs == null) return null;
    return Math.max(0, Math.floor((endMs - currentNowMs) / 1000));
  }, [endMs, currentNowMs]);

  let text = "--:--:--";
  let isEnded = false;
  if (remainSec != null) {
    text = formatRemainHms(remainSec);
    isEnded = remainSec <= 0;
  }

  if (showLabel) {
    text = `Ends in ${text}`;
  }

  return (
    <span
      className={className}
      style={
        isEnded
          ? {
              color: "var(--muted)",
            }
          : undefined
      }
    >
      {text}
    </span>
  );
}
